<template>
  <div class="request">
    <div class="request__details">
      <div v-if="ui.request_image" class="request__image"  :style="bg(ui.request_image)" />
      <div class="request__contact">
        <div class="request__line request__line--name">
          <div class="request__name" v-text="ui.request_name" />
        </div>
        <div class="request__line request__line--email">
          <a :href="'mailto:'+ui.request_email" class="request__email"
            v-text="ui.request_email" />
        </div>
        <div class="request__line request__line--phone">
          <a :href="'tel:'+ui.request_phone" class="request__email" v-text="ui.request_phone"
          />
        </div>
      </div>
    </div>
    <form class="request__form" @submit.prevent="validateBeforeSubmit">
      <div class="form__row">
        <div class="form__item">
          <input type="text" v-validate="'required|min:3'" class="form__input"
            name="name" placeholder=" " v-model="request.name"
            autocomplete='name' />
          <span class="form__placeholder" v-text="ui.request_name_label"
          />
          <span v-if="errors.has('name')" class="form__error" v-text="ui.error_name"
          />
        </div>
      </div>
      <div class="form__row">
        <div class="form__item">
          <input type="text" v-validate class="form__input" name="company"
            autocomplete='company' placeholder=" " v-model="request.company"
          />
          <span class="form__placeholder" v-text="ui.request_company_label"
          />
        </div>
      </div>
      <div class="form__row">
        <div class="form__item">
          <input type="email" v-validate="'required|email'" class="form__input"
            name="email" placeholder=" " v-model="request.email"
            autocomplete='email' />
          <span class="form__placeholder" v-text="ui.request_email_label"
          />
          <span v-if="errors.has('email')" class="form__error" v-text="ui.error_email"
          />
        </div>
      </div>
      <div class="form__row">
        <div class="form__item">
          <input type="text" v-validate class="form__input" name="phone"
            placeholder=" " v-model="request.phone" autocomplete='phone'
          />
          <span class="form__placeholder" v-text="ui.request_phone_label"
          />
          <span v-if="errors.has('phone')" class="form__error" v-text="ui.error_phone"
          />
        </div>
      </div>
      <div class="form__row">
        <div class="form__item">
          <textarea class="form__input" v-validate="'required|min:10'"
            rows="1" name="message" placeholder=" " v-model="request.message"
          />
          <span class="form__placeholder" v-text="ui.request_message_label"
          />
          <span v-if="errors.has('message')" class="form__error" v-text="ui.error_global"
          />
        </div>
      </div>
      <div class="form__row">
        <div class="form__item">
          <button class="form__submit more">
            <span class="more__text" v-text="ui.request_submit_label" />
            <i class="more__arrow" />
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Request',
  computed: {
    ...mapGetters(['ui'])
  },
  data() {
    return {
      request: {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: ''
      }
    }
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          var formObj = new FormData()
          Object.keys(this.request).forEach(f => {
            formObj.append(f, this.request[f])
          })
          axios({
            method: 'post',
            url: this.$store.getters.baseURL + '/endpoint/request',
            data: formObj,
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(response => {
              console.log(response)
              if (response.data === 'success') {
                console.log('success')
                // self.hasSuccess = true
                // self.hasSubscribed = false
              } else {
                console.log('fail:(')
                // self.hasSuccess = false
                // self.hasSubscribed = true
              }
            })
            .catch(error => {
              console.log(error)
            })
        }
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Request.vue